import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { IAPIDatasourceSummaryStats } from "../interfaces/api-datasources-summary-stats.interface";
import {map, tap} from "rxjs/operators";
import { DatasourceSummaryStatsModel } from "@app/dashboard/models/datasource-summary-stats.model";
import {CrossMatchSummaryStatsModel} from "@app/dashboard/models/crossmatch-summary-stats.model";
import {IAPICrossMatchSummaryStats} from "@app/dashboard/interfaces/api-crossmatch-summary-stats.interface";


@Injectable()
export class DashboardService {
    private _apiV2Base: string = environment.apiV2Url;
    
    constructor(private _httpClient: HttpClient) {}
    
    public getAllDataSourcesSummary(): Observable<DatasourceSummaryStatsModel[]> {
        return this._httpClient.get<IAPIDatasourceSummaryStats[]>(this._apiV2Base + 'senzing-dashboard/data_sources_summary')
            .pipe(
                map(response => DatasourceSummaryStatsModel.DeserializeList(response)),
                tap((model: DatasourceSummaryStatsModel[]) => {
                    model.sort((a, b) => {
                        if (a.dataSourceCode < b.dataSourceCode) {
                            return -1;
                        }

                        if (a.dataSourceCode > b.dataSourceCode) {
                            return 1;
                        }

                        return 0
                    })
                })
            )
    }
    
    public getCrossMatchSummary(dataSourceId: number): Observable<CrossMatchSummaryStatsModel[]> {
        const url: string = this._apiV2Base + 'senzing-dashboard/cross_source_summary/' + dataSourceId;
        return this._httpClient.get<IAPICrossMatchSummaryStats[]>(url)
            .pipe(
                map(response => CrossMatchSummaryStatsModel.DeserializeList(response)),
                tap((model: CrossMatchSummaryStatsModel[]) => {
                    model.sort((a, b) => {
                        if (a.relatedDataSourceCode < b.relatedDataSourceCode) {
                            return -1;
                        }

                        if (a.relatedDataSourceCode > b.relatedDataSourceCode) {
                            return 1;
                        }

                        return 0
                    })
                })
            )
    }
}